import rootApp from '../App.vue'
const STATICPATH = '/'

const rootComponent = () => {
  if (window.__MICRO_APP_ENVIRONMENT__ || window.top !== window) {
    return rootApp
  }
  return resolve => {
    setTimeout(() => {
      return require(['../view/introduce.vue'], resolve)
    }, 300)
  }
}

export default [
  {
    path: '/404',
    name: '404',
    component: resolve => require(['../components/404.vue'], resolve)
  },
  {
    path: STATICPATH,
    name: 'rootApp',
    component: rootComponent(),
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
          menuId: 9601
        },
        component: resolve => require(['../view/newHome.vue'], resolve)
      },
      {
        path: 'theme/:type',
        name: 'theme',
        meta: {
          title: '首页',
          menuId: 9601
        },
        component: resolve => require(['../view/theme.vue'], resolve)
      },
      {
        path: 'tools/:type',
        name: 'tools',
        meta: {
          title: '首页',
          menuId: 9601
        },
        component: resolve => require(['../view/toolHelp.vue'], resolve)
      },
      {
        path: 'commercial',
        name: 'commercial',
        meta: {
          title: '我的商脉',
          menuId: 9606
        },
        component: resolve => require(['../view/commercialPulse.vue'], resolve)
      },
      {
        path: 'commercial/:venderId',
        name: 'otherCommercial',
        meta: {
          title: '我的商脉',
          menuId: 9606
        },
        component: resolve => require(['../view/commercialPulse.vue'], resolve)
      },
      {
        path: 'followAndFan/:venderId',
        name: 'followAndFan',
        meta: {
          title: '我的商脉',
          menuId: 9606
        },
        component: resolve => require(['../view/followAndFan.vue'], resolve)
      },
      {
        path: 'create',
        name: 'createActivity',
        meta: {
          title: '创建活动',
          menuId: 9603
        },
        component: resolve => require(['../view/create.vue'], resolve)
      },
      {
        path: 'unionActivityList',
        name: 'unionActivityList',
        meta: {
          menuId: 81122
        },
        component: resolve => require(['../view/unionActivity/list.vue'], resolve)
      },
      {
        path: 'activityMain',
        name: 'activityMain',
        meta: {
          menuId: 9603
        },
        component: resolve => require(['../view/activityMain.vue'], resolve)
      },
      {
        path: 'marketMain',
        name: 'marketMain',
        meta: {
          menuId: 9602,
          title: '活动管理详情'
        },
        component: resolve => require(['../view/marketMain.vue'], resolve)
      },
      {
        path: '/invitation',
        name: 'invitation',
        meta: {
          title: '店铺邀请',
          menuId: 9604
        },
        component: resolve => require(['../view/invitationMain.vue'], resolve)
      },
      {
        path: 'help',
        name: 'help',
        meta: {
          title: '帮助中心',
          menuId: 9605
        },
        component: resolve => require(['../view/help.vue'], resolve)
      },
      {
        path: 'marketDetail/:activityId',
        name: 'marketDetail',
        meta: {
          title: '活动市场详情',
          menuId: 9602
        },
        component: resolve => require(['../components/marketList/marketDetail.vue'], resolve)
      },
      {
        path: 'managementDetail/:activityId',
        name: 'managementDetail',
        meta: {
          menuId: 9603
        },
        component: resolve => require(['../components/activityMain/managementDetail.vue'], resolve)
      },
      {
        path: 'unionActivityApply/:activityId',
        name: 'unionActivityApply',
        meta: {
          menuId: 81122
        },
        component: resolve => require(['../view/unionActivity/apply.vue'], resolve)
      },
      {
        path: '/unionActivityDetail/:activityId',
        name: 'unionActivityDetail',
        meta: {
          menuId: 81122
        },
        component: resolve => require(['../view/unionActivity/detail.vue'], resolve)
      },
      {
        path: '/rightsList',
        name: 'rightsList',
        meta: {
          title: '权益锦鲤',
          menuId: 81121
        },
        component: resolve => require(['../view/rights/list.vue'], resolve)
      },
      {
        path: '/rightsDetail/:activityId',
        name: 'rightsDetail',
        meta: {
          title: '权益锦鲤',
          menuId: 81121
        },
        component: resolve => require(['../view/rights/detail.vue'], resolve)
      },
      {
        path: '/rightsApply/:activityId',
        name: 'rightsApply',
        meta: {
          title: '权益锦鲤',
          menuId: 81121
        },
        component: resolve => require(['../view/rights/apply.vue'], resolve)
      },
      {
        path: ':activityId/:applyId',
        name: 'showAddSku',
        component: resolve => require(['../view/addSku.vue'], resolve)
      },
      {
        path: '/401',
        name: '401',
        component: resolve => require(['../components/401.vue'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js